export const validateLogin = (values) => {
  let errors = {};

  // Email Errors
  if (!values.email) {
    errors.email = "Email obbligatoria";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Indirizzo email non valido";
  }

  // Password Errors
  if (!values.password) {
    errors.password = "Password obbligatoria";
  } else if (values.password.length < 6) {
    errors.password = "La password deve essere lunga almeno 6 caratteri";
  }

  return errors;
};
